import { Star, MapPin, BadgeCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { serviceLabel, serviceBadge } from "@/lib/api";

export const ProCard = ({ pro, index = 0, onView }) => {
  const badgeClass = serviceBadge(pro.category);
  return (
    <div className="card-soft p-6 flex flex-col fade-up" style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`directory-pro-card-${pro.id}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-14 h-14 rounded-xl bg-[color:var(--bg-3)] overflow-hidden grid place-items-center shrink-0">
            {pro.logo ? <img src={pro.logo} alt={pro.name} className="w-full h-full object-cover" />
              : <span className="font-display font-extrabold text-lg text-[color:var(--emerald)]">{pro.name[0]}</span>}
          </div>
          <div>
            <h3 className="font-display font-bold text-lg leading-tight text-[color:var(--navy)]">{pro.name}</h3>
            <div className="flex items-center gap-1 text-sm text-[color:var(--ink-3)] mt-0.5">
              <MapPin className="w-3.5 h-3.5" /> {pro.city}, CA
            </div>
          </div>
        </div>
        {pro.featured && <span className="text-[10px] font-mono uppercase tracking-wider badge-verified px-2 py-1 rounded-md">Featured</span>}
      </div>

      <div className="flex items-center gap-2 mt-4">
        <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${badgeClass}`}>{serviceLabel(pro.category)}</span>
        {pro.verified && <span className="text-xs font-semibold px-2.5 py-1 rounded-full badge-verified inline-flex items-center gap-1"><BadgeCheck className="w-3.5 h-3.5" /> Verified</span>}
      </div>

      <div className="flex items-center gap-1.5 mt-4">
        <Star className="w-4 h-4 fill-amber-400 text-amber-400" />
        <span className="font-semibold text-[color:var(--navy)]">{pro.rating.toFixed(1)}</span>
        <span className="text-sm text-[color:var(--ink-3)]">({pro.review_count} reviews)</span>
      </div>

      <p className="text-sm text-[color:var(--ink-2)] mt-3 line-clamp-2 flex-1">{pro.description}</p>

      <div className="flex flex-wrap gap-1.5 mt-4">
        {pro.services.slice(0, 4).map((s) => (
          <span key={s} className="text-xs bg-[color:var(--bg-3)] text-[color:var(--ink-2)] px-2 py-0.5 rounded-md">{s}</span>
        ))}
      </div>

      <Button onClick={() => onView(pro)} data-testid={`directory-view-pro-${pro.id}`}
        className="btn-primary rounded-full mt-5 w-full font-semibold">View & Request Quote</Button>
    </div>
  );
};
